<template>
  <a-config-provider
      :getPopupContainer="getPopupContainer"
      :locale="zhCN"
      :theme="{
        token: config
      }"
  >

    <a-spin id="loading" tip="加载中..." :spinning="store.state.spinning">
    </a-spin>

    <router-view/>
  </a-config-provider>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {PRIMARY_COLOR, PRIMARY_COLOR_ACTIVE, PRIMARY_COLOR_HOVER} from '@/hook/useConfig'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh');

const store = useStore()

const config = ref({
  colorPrimary: PRIMARY_COLOR,
  colorInfo: PRIMARY_COLOR,
  colorLink: PRIMARY_COLOR,
  colorLinkActive: PRIMARY_COLOR_ACTIVE,
  colorLinkHover: PRIMARY_COLOR_HOVER,
});

const getPopupContainer = (el, dialogContext) => {
  if (dialogContext) {
    return dialogContext.parentNode();
  } else {
    // return document.body;
    return el.parentNode
  }
}

onMounted(() => {
})

</script>
<style lang="less" scoped>
#loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99999999;
  background: rgba(255, 255, 255, 0.7) !important;
  padding-top: 200px;
}
</style>